import type { FunctionComponent } from 'react';
import React from 'react';
import type { ButtonProps } from '@material-ui/core/Button';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import classNames from 'classnames';

export interface OptionButtonProps extends ButtonProps {
  selected?: boolean;
}

const UnstyledOptionButton: FunctionComponent<OptionButtonProps> = (props) => {
  const { children, className, selected, ...otherProps } = props;

  return (
    <div className={classNames(className, 'button-wrapper', selected && 'selected')}>
      <Button disableRipple fullWidth variant="outlined" {...otherProps}>
        {children}
      </Button>
    </div>
  );
};

export const OptionButton = styled(UnstyledOptionButton)`
  & button {
    min-height: 3rem;
    background-color: transparent;
    margin-right: 0.5rem;
    border: 1px solid ${({ theme, selected }) => (selected ? theme.palette.primary.main : theme.palette.grey[270])};
    border-radius: 9999px;
    font-weight: 500;
    padding: 0.7rem 1rem;
    line-height: 1rem;
    color: #000;
    height: 100%;
  }

  &.selected button {
    color: ${({ theme }) => theme.palette.primary.main};
  }

  &.button-wrapper {
    height: 100%;
  }
`;
